var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    'content': _vm.text,
    'trigger': 'click, hover',
    'placement': 'auto',
    }),expression:"{\n    'content': text,\n    'trigger': 'click, hover',\n    'placement': 'auto',\n    }"}],staticClass:"hint"},[_c('i',{staticClass:"far fa-question-circle hint"})])}
var staticRenderFns = []

export { render, staticRenderFns }